import { useMutation, useQueryClient } from '@tanstack/react-query';
import { proposalConfigurationApi } from '@/api/commercial/proposal-configurations';
import { toast } from '@/hooks/use-toast';

export function useSaveProposalConfiguration(proposalId?: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: {
      groupId: string;
      profiles: Array<{ profileId: string; quantity: number }>;
    }) => {
      if (!proposalId) throw new Error('Proposal id is required');
      return proposalConfigurationApi.saveConfiguration(proposalId, payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['proposal-configurations', proposalId],
      });
      toast({ title: 'Configuração salva com sucesso' });
    },
    onError: () => {
      toast({
        title: 'Erro ao salvar configuração',
        variant: 'destructive',
      });
    },
  });
}
